/* eslint-disable jsx-a11y/label-has-for */

import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from '../../Forms.messages';

import { TranslatedErrorMessage } from '../../../ErrorMessage/ErrorMessage';

const TEXT_TYPES = ['text', 'password', 'email', 'tel'];

const hasWarning = ({ touched, error, warning }) =>
  (touched && error) || (touched && warning);

const Text = ({
  input,
  label,
  labelName,
  classNames,
  type,
  isRequired,
  isActiveField,
  disabled,
  isFilled,
  showOptionalText,
  meta: { touched, error, warning },
}) => {
  const hasWarningClass = hasWarning({ touched, error, warning });

  const classes = {
    input: true,
    pb2: true,
    pt1: true,
  };

  const inputContainerClasses = {
    active: isActiveField,
    field: true,
    filled: isFilled,
    relative: true,
    text: true,
  };

  const inputInnerClasses = {
    'delicateShadow': true,
    'b--light-blue': isActiveField,
    'b--white': !hasWarningClass && !disabled,
    'b--none': disabled,
    'b--red': hasWarningClass,
    'bg-white': !disabled,
    'bg-black-05': disabled,
    'w-100': true,
    'ba': true,
    'br2': true,
    'pa1': true,
    [classNames]: !!classNames,
  };

  const inputElementClasses = {
    'b--transparent': true,
    'bg-white': !disabled,
    'bg-transparent': disabled,
    'black-90': !disabled,
    'black-50': disabled,
    'input-reset': true,
    'trade-gothic-regular': true,
    'w-100': true,
    'ba': true,
    'f5': true,
    'pb2': true,
    'pl3': true,
    'pr3': true,
    'pt3': true,
  };

  const errorElementClasses = {
    dn: !hasWarningClass,
    absolute: true,
    red: true,
  };

  const labelElementClasses = {
    'w-100': true,
    'absolute': true,
    'f6': true,
    'i': !isActiveField && !isFilled,
    'red': hasWarningClass,
  };

  const errorElement = (
    <span>{error ? <TranslatedErrorMessage error={error} /> : null}</span>
  );

  const labelElement = (
    <label htmlFor={labelName} className={classnames(labelElementClasses)}>
      <span className="mr2">{label}</span>
      {!isRequired && showOptionalText && (
        <span className="mr2">
          (
          <FormattedMessage {...messages.optional} />)
        </span>
      )}
      <span className={classnames(errorElementClasses)}>{errorElement}</span>
    </label>
  );

  const fieldElement = (
    <div className={classnames(inputInnerClasses)}>
      <input
        {...input}
        type={type}
        name={labelName}
        id={labelName}
        // NOTE: Re-add this to enable "real" HTML5 validation
        // required={isRequired}
        className={classnames(inputElementClasses)}
        style={{ cursor: disabled ? 'not-allowed' : 'initial' }}
        disabled={!!disabled}
      />
    </div>
  );

  return (
    <div className={classnames(classes)}>
      <div className={classnames(inputContainerClasses)}>
        {labelElement}
        {fieldElement}
      </div>
    </div>
  );
};

Text.defaultProps = {
  isRequired: false,
  isActiveField: false,
  isFilled: false,
  classNames: null,
  disabled: false,
  showOptionalText: false,
};

Text.propTypes = {
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  isActiveField: PropTypes.bool,
  isFilled: PropTypes.bool,
  input: PropTypes.object.isRequired, // eslint-disable-line
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  labelName: PropTypes.string.isRequired,
  type: PropTypes.oneOf(TEXT_TYPES).isRequired,
  classNames: PropTypes.string,
  showOptionalText: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    warning: PropTypes.string,
  }).isRequired,
};

export default Text;
